import {Component, Inject, OnInit, ChangeDetectionStrategy} from '@angular/core';

import {Survey, SurveyRequest} from '../../../api/models/survey';

import {MessageService} from '../../../api/services/message.service';
import {SurveyService} from '../../../api/services/survey.service';

import {
  ConfirmationDialogComponent
} from '../../general-purpose/dialogs/confirmation-dialog/confirmation-dialog.component';
import {SurveyPropertiesComponent} from '../survey-create/steps/survey-properties/survey-properties.component';
import {UploadComponent} from '../survey-create/steps/upload/upload.component';
import {ReactiveFormsModule} from "@angular/forms";
import {WaButtonDirective, WaDialogDirective, WaIconDirective} from "angular-awesome";
import {Dialog, DIALOG_DATA, DialogRef} from "@angular/cdk/dialog";

@Component({
  selector: 'app-survey-edit',
  templateUrl: './survey-edit.component.html',
  styleUrls: ['./survey-edit.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SurveyPropertiesComponent, UploadComponent, ReactiveFormsModule, WaButtonDirective, WaDialogDirective, WaIconDirective]
})
export class SurveyEditComponent implements OnInit {

  processing: boolean = false;

  properties: SurveyRequest | null = null;
  selectedFile: File | null = null;
  survey: Survey | null = null;

  constructor(private msgService: MessageService,
              private surveyService: SurveyService,
              private dialog: Dialog,
              private dialogRef: DialogRef<Survey>,
              @Inject(DIALOG_DATA) data: any) {

    if (!data) return;
    this.survey = data.survey || null;
  }

  ngOnInit(): void {
    const survey = this.survey;

    if (!survey)
      return;

    this.properties = {
      name: survey.name,
      begin: survey.begin,
      end: survey.end
    };
  }

  async save(): Promise<void> {
    if (!this.stateValid() || !this.surveyChanged())
      return;

    const id = this.survey!.id;
    const file = this.selectedFile;
    const toUpdate: SurveyRequest = {
      name: this.properties!.name,
      begin: this.properties!.begin,
      end: this.properties!.end
    };

    this.setProcessing(true);

    try {

      let updatedSurvey = await this.surveyService.update(id, toUpdate);
      const upload = file && await this.surveyService.upload(id, file);
      updatedSurvey = upload ? upload.survey : updatedSurvey;
      this.dialogRef.close(updatedSurvey);

    } catch (error: any) {

      this.msgService.log(error);
      this.msgService.showSimple('Could not update survey.')
    }

    this.setProcessing(false);
  }

  cancel(): void {
    if (!this.surveyChanged()) {
      this.dialogRef.close();
      return;
    }

    const ref = this.dialog.open(ConfirmationDialogComponent, {
      disableClose: true,
      data: {
        title: 'Discard Changes?',
        message: 'Unsaved changes will be lost. Leave anyway?'
      }
    });

    ref.closed.subscribe(data => {
      if (data) this.dialogRef.close();
    });
  }

  surveyChanged(): boolean {
    const survey = this.survey;
    const props = this.properties;

    if (!survey || !props)
      return false;

    return survey.name !== props.name ||
      survey.begin !== props.begin ||
      survey.end !== props.end ||
      !!this.selectedFile;
  }

  stateValid(): boolean {
    return !!this.survey &&
      !!this.properties &&
      (!this.selectedFile ||
        this.selectedFile.type === 'application/json');
  }

  private setProcessing(processing: boolean): void {
    this.processing = processing;
  }
}
